var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"hero"},[_c('v-container',[_c(_vm.currentHomePage,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }